<template>
  <div class="w-full">
    <Head title="Panel — KLNP" />
    <div class="mb-8">
      <h1 class="mb-2 text-3xl font-bold text-gray-900">Administracja strony Kliniki Przyczynowego Leczenia Niepłodności</h1>
      <p class="text-gray-600">
        Zarządzaj treścią i ustawieniami strony Kliniki Przyczynowego Leczenia Niepłodności.
      </p>
    </div>

    <div class="rounded-lg bg-white shadow-sm">
      <div class="px-6 py-5">
        <p class="text-gray-600">
          To jest panel administracyjny do zarządzania stroną statyczną Kliniki Przyczynowego Leczenia Niepłodności.
        </p>
        <div class="mt-4">
          <Link
            :href="$routes.infertility_treatment_clinic()"
            class="text-sm font-medium text-indigo-600 hover:text-indigo-500"
            target="_blank"
          >
            Zobacz stronę Kliniki Przyczynowego Leczenia Niepłodności →
          </Link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3';
import AdminInfertilityTreatmentClinicLayout from '@/Layouts/AdminInfertilityTreatmentClinic.vue';

export default {
  components: {
    Head,
    Link,
  },
  layout: AdminInfertilityTreatmentClinicLayout,
};
</script>
